export const visit = (vm, at) => {
at({ "sv": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Tyv\xE4rr, vi kunde inte verifiera din e-postadress." } } } });
};